import axios from "axios";
import Config from "src/config";

const v2_actionClienteConfigCheck = (clienteId, fields) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/clientes/${clienteId}/check`,
        params: {
            fields: fields
        }
    });
};

export default v2_actionClienteConfigCheck;
